import PropTypes from 'prop-types'
import React from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import { Apps } from '@mui/icons-material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    height: 64,
    borderRight: `0.5px solid ${theme.palette.grey[200]}`,
    padding: theme.spacing(0, 0.5),
  },
}))

const MetricCardsBarCollapsed = ({ onGridOpen, gridAnchorRef }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Tooltip title="View all metrics" arrow>
        <IconButton onClick={onGridOpen} size="medium" ref={gridAnchorRef}>
          <Apps />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

MetricCardsBarCollapsed.propTypes = {
  onGridOpen: PropTypes.func.isRequired,
  gridAnchorRef: PropTypes.object.isRequired,
}

export default MetricCardsBarCollapsed
